export enum RoutePath {
  Login = "/login",
  Logout = "/logout",
  Status = "/status",
}
